import { createFileRoute } from '@tanstack/react-router'
import { ChargersPage } from '@/pages/chargers'

export const Route = createFileRoute('/_authenticated/chargers')({
  component: ChargersPage,
})